import React from 'react';
import PropTypes from 'prop-types';
import { cloneObject } from '../../common/utils';
import Icon from './Icon';

const IllustratedDescription = props => {
  const { iconName, children, className } = props;
  const wrapperAttributes = cloneObject(props, {}, ['iconName', 'children']);
  const classNames = className ? className.split(' ') : [];
  classNames.push('illustrated-description');
  wrapperAttributes.className = classNames.join(' ');

  return (
    <figure {...wrapperAttributes}>
      <Icon iconName={iconName} className='illustration' />
      <figcaption className='text-description'>{children}</figcaption>
    </figure>
  );
};

IllustratedDescription.propTypes = {
  iconName: PropTypes.string.isRequired
};

export default IllustratedDescription;